import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators } from 'redux';
import * as folioActions from '../actions/folio-actions';
import classnames from 'classnames';
import LandingGallery from '../components/LandingGallery';
import styled from 'styled-components';

import '../styles.scss';

const Landing = styled.div`

.landing__intro {
    color: #f9e7cc;
    display: inline-block;
    font-family: Alegreya, serif;
    font-size: 20px;
    padding: 0 20px;
    margin-bottom: 40px;
    margin-top: 70px;
    text-align: left;
    vertical-align: top;
    
    @media (min-width: 330px) {
      margin-top: 110px;
    }

  @media (min-width: 480px) {
      height: 100vh;
      font-size: 30px;
      margin-top: 200px;
      padding: 40px;
      width: 50%;
    }
  }
`;

class LandingContainer extends Component {

  render() {
    const classes = classnames(['wrapper--inner']);

    return (
        <div className={ classes }>
          <Landing>
            <div className="landing__intro">Chevo Studios creates artful public spaces and integrated art elements for architecture and landscapes.</div>
            <LandingGallery />
          </Landing>
        </div>
    );
  }
}

LandingContainer.propTypes = {
  actions: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(folioActions, dispatch)
  }
}

export default connect(mapDispatchToProps)(LandingContainer);




// WEBPACK FOOTER //
// ./src/containers/landing.js